export default {
  txNumberCopied: "تم نسخ رقم المعاملة.",
  deposit: {
    successRialDeposit: "تم إيداع الريال بنجاح.",
    trxNumber: "رقم المعاملة",
    referCode: "كود المرجع",
    trackingCode: "كود التتبع",
    payAmount: "مبلغ الدفع",
    registerDate: "تاريخ ووقت التسجيل",
    trxStatus: "عرض حالة المعاملة",
    goToWallet: "اذهب إلى صفحة المحفظة",
    suspendTrx: "المعاملة معلقة",
    successTrx:
      "تم تسجيل معاملتك وتم الدفع بنجاح في البنك. ومع ذلك، لم يتم تسجيل رقم البطاقة الذي دفعت به في حسابك مسبقًا. لذلك، تحتاج معاملتك إلى المراجعة. لمزيد من المعلومات، يمكنك الاتصال بدعم Excoino.",
    addCard: "تسجيل بطاقة بنكية",
    unsuccessfulTrx: "غير ناجحة",
    depositAgain: "إيداع مرة أخرى",
    offlineDeposit: {
      registerInfo: "تم تسجيل معلومات إيداعك غير المتصل بنجاح",
      increaseRialBalance:
        "بعد مراجعة واعتماد الإيداع، سيتم زيادة رصيد الريال الخاص بك.",
      depositAmount: "مبلغ الإيداع",
      registerDate: "تاريخ ووقت التسجيل",
      sourceBank: "البنك المصدر",
      depositType: "نوع الإيداع",
      trackingCode: "كود التتبع",
      status: "الحالة",
      goToWallet: "اذهب إلى المحفظة"
    },
    resubmitDeposit: {
      confirmOrder: "تأكيد الطلب",
      dueTime: "الوقت المتبقي لإكمال هذا الطلب",
      trxNumber: "رقم المعاملة",
      payAmount: "مبلغ الدفع",
      selectGateWay: "اختر بوابة الدفع",
      cancelOrder: "إلغاء الطلب",
      goToGateWay: "اذهب إلى بوابة الدفع"
    }
  },
  transfer: {
    transfer: "أنت تقوم بتحويل",
    tokenType: "نوع العملة",
    continueProcess: "تابع عملية التحويل",
    registeredRequest: "تم تسجيل طلبك بنجاح.",
    excoinoConfirmation: "بعد تأكيد Excoino، سيتم إكمال طلبك.",
    trxNumber: "رقم المعاملة",
    registeredDate: "تاريخ ووقت التسجيل",
    amount: "المبلغ",
    goToWallet: "اذهب إلى المحفظة",
    goToMarket: "اذهب إلى سوق Excoino",
    prevStep: "العودة إلى الخطوة السابقة",
    cancelOrder: "إلغاء الطلب"
  },
  withdrawal: {
    cancelOrder: "إلغاء الطلب",
    crypto: {
      youSend: "أنت تقوم بإرسال",
      tokenType: "نوع العملة",
      destAddress: "عنوان المحفظة المستهدفة",
      networkType: "نوع الشبكة",
      withoutDeductionOfFee: "المبلغ بدون خصم الرسوم",
      fee: "الرسوم",
      continueProcess: "تابع عملية سحب العملة المشفرة",
      registeredSuccessful: "تم تسجيل طلبك بنجاح",
      excoinoConfirm: "بعد تأكيد Excoino، سيتم إكمال طلبك.",
      trxNumber: "رقم المعاملة",
      amount: "المبلغ",
      registerDate: "تاريخ ووقت التسجيل",
      trxStatus: "عرض حالة المعاملة",
      goToWallet: "اذهب إلى المحفظة"
    },
    rial: {
      successWithdraw: "تم تسجيل طلب السحب بنجاح.",
      excoinoConfirm: "بعد تأكيد Excoino، سيتم إكمال طلبك.",
      trxNumber: "رقم المعاملة",
      amount: "المبلغ"
    }
  }
};
